/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import { ErrorMessage } from 'formik';
import Input from '../../../components/Input/input.component';
import WidgetModalForm, {
	ModalFormContext,
} from '../../../components/Modal/modalForm.component';
import Required from '../../../components/Required/required.component';
import { EntradaValidationSchema } from './modal.validate';
import { numberMask } from '../../../components/Input/Masks';

export default class EntradaModal extends Component {
	constructor(props) {
		super(props);
		this.state = {
			entrada: {
				id: this.props.doacaoId,
				quantidade: '',
			},
		};
	}

	render() {
		const {
			props: {
				isOpenEntrada,
				handleCloseEntrada,
				handleSalvarEntrada,
				nomeItem,
			},
			state: {
				entrada,
			},
		} = this;

		return (
			<WidgetModalForm
				textCancelar='Cancelar'
				textConfirmar='Cadastrar'
				initialValues={entrada}
				validationSchema={EntradaValidationSchema}
				title='Registrar entrada'
				confirmar={handleSalvarEntrada}
				isOpen={isOpenEntrada}
				cancelar={handleCloseEntrada}
				size='lg'
				modalConfirmarFechar
				modalConfirmarCancelar
				modalConfirmarCancelarTitulo='Atenção!'
				modalConfirmarCancelarCorpo='Tem certeza que deseja cancelar? Todos os dados preenchidos serão perdidos.'
				iconCancelar='fas fa-times'
				iconConfirmar='fas fa-save'
			>
				<ModalFormContext.Consumer>
					{({ values, handleChange }) => (
						<div>
							<div>
								<p><strong>Item:</strong> {nomeItem} </p>
							</div>
							<div className='row'>
								<div className='col-md-12 form-group'>
									<label>
										Quantidade: <Required />
									</label>
									<Input
										type='text'
										mask={numberMask}
										name='quantidade'
										maxLength='11'
										onChange={handleChange}
										value={values.quantidade}
									/>
									<ErrorMessage
										name='quantidade'
										render={msg => (
											<span className='text-danger'>
												{msg}
											</span>
										)}
									/>
								</div>
							</div>
						</div>
					)}
				</ModalFormContext.Consumer>
			</WidgetModalForm>
		);
	}
}
